// extracted by mini-css-extract-plugin
export default {"flex":"rhypoBb6bxhU4u5EZyiHxw==","flex1":"v7fPsFiVy2mqgeP6W65bTg==","installPage":"dQESHmr-zYu5Dguql6PMqg==","subtitle":"_6jxJXSinPPfmBXaM0-7ZQA=="};